/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'number',
      maximum: 100,
      minimum: 0,
    },
    unit: {
      type: 'string',
      enum: ['PERCENTAGE'],
      minLength: 1,
    },
  },
  required: ['value', 'unit'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    prov_approximate_of_supvs_who_can_communicate_in_this_language_1: valueSchema,
  },
}
